import { render, staticRenderFns } from "./car-finance-detail.vue?vue&type=template&id=8f67464c"
import script from "./car-finance-detail.vue?vue&type=script&lang=js"
export * from "./car-finance-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports